import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinearProgressBarComponent } from './linear-progress-bar.component';

@NgModule({
  declarations: [LinearProgressBarComponent],
  imports: [CommonModule],
  exports: [LinearProgressBarComponent],
})
export class LinearProgressBarModule {}
